/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Templates_Settings_Contact_Extend_Wrapup_CountInputs */

const en_forms_templates_settings_contact_extend_wrapup_count = /** @type {(inputs: Forms_Templates_Settings_Contact_Extend_Wrapup_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count`)
};

const de_forms_templates_settings_contact_extend_wrapup_count = /** @type {(inputs: Forms_Templates_Settings_Contact_Extend_Wrapup_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count`)
};

/**
* | output |
* | --- |
* | "Count" |
*
* @param {Forms_Templates_Settings_Contact_Extend_Wrapup_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_templates_settings_contact_extend_wrapup_count = /** @type {((inputs?: Forms_Templates_Settings_Contact_Extend_Wrapup_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Templates_Settings_Contact_Extend_Wrapup_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_templates_settings_contact_extend_wrapup_count(inputs)
	return de_forms_templates_settings_contact_extend_wrapup_count(inputs)
});